import styled from 'styled-components';

const Box = styled.div`
  background: white;
  padding: 2rem 3rem;
  margin-bottom: 16px;
  border-radius: 8px;
  border: 1px solid #d6e4f2;
`;
const BoxTitle = styled.div`
  font-size: 24px;
  font-weight: 500;
  margin-left: 16px;
`;
const BoxTitleContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  cursor: pointer;
`;
const BoxContentContainer = styled.div`
  background: #eff5fb;
  padding: 32px;
  margin-top: 16px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
`;

const BoxContentQuestion = styled.div`
  border: 1px solid #b9cce1;
  border-radius: 4px;
  background: #d6e4f2;
  padding: 16px 32px;
  width: 100%;
`;
const AccordionContent = styled.div<{ $isOpen: boolean }>`
  overflow: hidden;
  max-height: ${({ $isOpen }) => ($isOpen ? '2000px' : '0')};
  opacity: ${({ $isOpen }) => ($isOpen ? 1 : 0)};
  transition:
    max-height 0.35s ease,
    opacity 0.25s ease;
`;
const Chevron = styled.div<{ $isOpen: boolean }>`
  margin-left: auto;
  width: 36px;
  height: 36px;

  display: flex;
  align-items: center;
  justify-content: center;

  transform-origin: center;

  transition: transform 0.25s ease;

  transform: ${({ $isOpen }) => ($isOpen ? 'rotate(0deg)' : 'rotate(180deg)')};
  border: 1px solid #21aae8;
  padding: 8px;
  border-radius: 50%;
`;

export default {
  Box,
  BoxTitle,
  BoxTitleContainer,
  BoxContentContainer,
  BoxContentQuestion,
  AccordionContent,
  Chevron,
};
